export default __webpack_public_path__ + "static/media/nft-logo.fb241a9f.svg";